import React, { useState } from 'react';
import { TableComponents, PageContainer, ExportButton, Icons } from 'components';
import { useExportFile } from 'hooks';
import { Grid, Button } from '@mui/material';
import { columns, columnsId } from './components/columns';
import ServiceSetDialog from './ServiceSetDialog';
import ServiceProviderServices from './services/ServiceProviderServices';
import jMoment from 'moment-jalaali';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import { useStyles } from './style';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';
import {
  getExportNumberOfCallsUrl,
} from 'URLs';
export default function ServiceProvider() {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [currentServiceSetId, setCurrentServiceSetId] = React.useState(null);
  const currencyText = useCurrencyUnit();
  const actionsList =
    getDynamicObjectAction([
      'providersWebServicePage',
      'exportProvidersWebServiceBtn'

    ])
  // bellow variables are for exporting
  const [filterParams, setFilterParams] = useState(null);
  const [loading, setLoading] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const { downloadFile, isExporting } = useExportFile({
    url: getExportNumberOfCallsUrl(),
    filename: 'service-providers-report',
  });

  const getServiceProvider = async (query) => {
    setLoading(true);

    const filter = [];
    let orderBy = [];
    const parentParams = [];
    const params = {
      page: query ? query?.pageNumber : page,
      size: query ? query?.pageSize : size,
      startYearMonth: jMoment(new Date())
        .subtract('180', 'days')
        .locale('en')
        ?.format('jYYYY/jMM/jDD 00:00:00'),
      endYearMonth: jMoment(new Date()).locale('en')?.format('jYYYY/jMM/jDD 23:59:59'),
    };

    if (query?.filters.length) {
      query.filters.forEach((row) => {
        Array.isArray(columnsId[row.column.field])
          ? columnsId[row.column.field].forEach((id) =>
            filter.push({
              id,
              value: row.value,
            }),
          )
          : filter.push({
            id: columnsId[row.column.field],
            value: row.value,
          });
      });
    }

    if (query?.orderBy) {
      const desc = query.orderDirection === 'desc';
      if (!query?.orderBy.field) {
        orderBy = [];
      } else {
        switch (query?.orderBy?.title) {
          case 'تاریخ و زمان فراخوانی':
            orderBy = [
              { name: 'تاریخ فراخوانی', desc },
              { name: 'زمان فراخوانی', desc },
            ];
            break;
          case 'مجموع تعداد فراخوانی موفق':
            orderBy = [
              { name: 'از مجموع تعداد فراخوانی موفق', desc },
              { name: 'تا مجموع تعداد فراخوانی موفق', desc },
            ];
            break;
          case 'مجموع تعداد فراخوانی ناموفق':
            orderBy = [
              { name: 'از مجموع تعداد فراخوانی ناموفق', desc },
              { name: 'تا مجموع تعداد فراخوانی ناموفق', desc },
            ];
            break;
          case 'مجموع تعداد فراخوانی':
            orderBy = [
              { name: 'از مجموع تعداد فراخوانی ها', desc },
              { name: 'تا مجموع تعداد فراخوانی ها', desc },
            ];
            break;
          case `مجموع مبلغ فروش (${currencyText})`:
            orderBy = [
              { name: 'از مجموع مبلغ فروش', desc },
              { name: 'تا مجموع مبلغ فروش', desc },
            ];
            break;
          default:
            orderBy = [{ name: query?.orderBy.title, desc }];
            break;
        }
      }
    }

    const postBodyParams = {
      filterVOS: filter,
      parentParams,
      orderByElementVOS: orderBy,
    };

    setFilterParams({ data: postBodyParams, params });

    try {
      const res = await ServiceProviderServices.getServiceProviders(postBodyParams, params);
      const data = res.data.result.rows.map((row, key) => ({
        serviceId: row.cols[0],
        serviceName: row.cols[1],
        PersianServiceName: row.cols[2],
        salerId: row.cols[3],
        salerName: row.cols[4],
        numberOfSuccessCalls: row.cols[5],
        numberOfFailedCalls: row.cols[6],
        numberOfCalls: row.cols[7],
        totalSales: row.cols[8],
      }));
      setLoading(false);

      return {
        data,
        page: query ? query?.pageNumber : page,
        totalCount: res.data.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  const handleOpenDialog = (serviceSetId) => {
    setCurrentServiceSetId(serviceSetId);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const SeeDetailBtn = ({ id }) => {
    return (
      <Button
        startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
        variant="contained"
        className={classes.expandBtn}
        onClick={() => {
          handleOpenDialog(id);
        }}
      >
        جزییات سرویس
      </Button>
    );
  };

  const hint =
    'در این صفحه می‌توانید گزارش تجمیعی فراخوانی‌ سرویس‌های خود در یک ماهه اخیر را مشاهده کنید.';

  return (
    <>
      <PageContainer title="گزارش فراخوانی‌ها" breadcrumbs={constBreadCrumbsTitle.SERVICES_SERVICE_PROVIDERS} description={hint}>
        <Grid
          container
          justifyContent="flex-end"
          alignItems="flex-end"
          style={{ marginTop: 16, marginInlineEnd: 16, marginBottom: 8 }}
        >
          {actionsList['exportProvidersWebServiceBtn'] && (
            <Grid item style={{ marginBottom: 8 }}>
              <ExportButton
                loading={isExporting}
                types={['xls', 'csv']}
                onExport={onExport}
              />
            </Grid>
          )}
        </Grid>
        {actionsList['providersWebServicePage'] && currencyText && (
          <TableComponents
            data={getServiceProvider}
            columns={columns(SeeDetailBtn , currencyText)}
            isLoading={loading}
            onChange={(ps) => {
              setPage(ps?.pageNumber);
              setSize(ps?.pageSize);
              return getServiceProvider(ps);
            }}
          />
        )}
        <ServiceSetDialog
          open={openDialog}
          onClose={handleCloseDialog}
          serviceSetId={currentServiceSetId}
        />
      </PageContainer>
    </>
  );
}
